module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-section"
  }, [_c('div', {
    staticClass: "custom-home-section__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "custom-home-section__title",
    class: {
      "custom-home-section__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-section__body"
  }, [_c('div', {
    staticClass: "custom-home-section__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content)
    }
  }), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointLine,
        options: _vm.intersectionLineOptions
      }),
      expression: "{ active: true, callback: onWaypointLine, options: intersectionLineOptions }"
    }],
    staticClass: "custom-home-section__seperator",
    class: {
      "custom-home-section__seperator--active": _vm.fadeLine
    }
  }, [_c('div', {
    staticClass: "custom-home-section__orange-line"
  })]), _c('div', {
    staticClass: "custom-home-section__cta",
    domProps: {
      "innerHTML": _vm._s(_vm.props.cta)
    }
  })]), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointPhone,
        options: _vm.intersectionPhoneOptions
      }),
      expression: "{ active: true, callback: onWaypointPhone, options: intersectionPhoneOptions }"
    }],
    staticClass: "custom-home-section__video",
    class: {
      "custom-home-section__video--active": _vm.fadePhone
    }
  }, [_c('div', {
    staticClass: "custom-home-section__overlay"
  }, [_c('img', {
    staticClass: "custom-home-section__image",
    attrs: {
      "src": _vm.props.image,
      "alt": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  })])])]), _c('transition', {
    attrs: {
      "name": "fade-in-modal"
    }
  }, [_c('HomeVideoModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "props": _vm.props
    },
    on: {
      "closeHomeVideoModal": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a069e8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-section/custom-home-section.pug
// module id = 580
// module chunks = 1